import { render, staticRenderFns } from "./StudentDetails.vue?vue&type=template&id=30537d0a&scoped=true"
import script from "./StudentDetails.vue?vue&type=script&lang=js"
export * from "./StudentDetails.vue?vue&type=script&lang=js"
import style0 from "./StudentDetails.vue?vue&type=style&index=0&id=30537d0a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30537d0a",
  null
  
)

export default component.exports